import React from 'react';
import { BodyText, Card, Header1Text } from '../../ui-toolkit/components';
import styled from 'styled-components';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';

const StyledCard = styled(Card)`
  padding: ${(props) => `${props.theme.spacing.baseValue * 12}${props.theme.spacing.baseUnit}`};
  text-align: center;
`;

interface IPermissionWrapperProps {
  allowedPermissions: ePermissions[];
  requireAll?: boolean;
  children: React.ReactNode;
}

export const PermissionWrapper: React.FC<IPermissionWrapperProps> = ({ allowedPermissions, children, requireAll }) => {
  const isAuthorized = useHasPermissions(allowedPermissions, requireAll);
  return (
    <>
      {isAuthorized ? (
        children
      ) : (
        <StyledCard>
          <Header1Text>This page isn't available</Header1Text>
          <BodyText>Your permissions may have changed.</BodyText>
        </StyledCard>
      )}
    </>
  );
};
